import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import ShareIcon from "@material-ui/icons/Share";

import React from "react";

import Props from "@sentrei/common/types/components/SpaceCard";
import Link from "@sentrei/ui/components/Link";

import SpaceCardStyles from "./SpaceCardStyles";

export default function SpaceCard({space}: Props): JSX.Element {
  const classes = SpaceCardStyles();

  return (
    <Card className={classes.root}>
      <CardActionArea className={classes.placeholder}>
        <Link href="/[id]" as={`/${space.uid}`}>
          {space.photo ? (
            <CardMedia className={classes.media} image={space.photo} />
          ) : (
            <Box className={classes.media} />
          )}
        </Link>
      </CardActionArea>
      <CardContent>
        <Typography
          component="h3"
          variant="h4"
          align="center"
          color="textPrimary"
          gutterBottom
        >
          {space.name}
        </Typography>
        <Box p={1} />
        <div className={classes.container}>
          <Grid
            container
            direction="row"
            justify="flex-end"
            alignItems="center"
          >
            <IconButton aria-label="share">
              <ShareIcon />
            </IconButton>
          </Grid>
        </div>
      </CardContent>
    </Card>
  );
}
